import React from "react"
import MUITypography, {
  TypographyProps as MUITypographyProps,
} from "@mui/material/Typography"
import { MUIMappedTypography } from "./mantine/Typography.mantine"

export type TypographyProps =
  | ({ new?: false } & MUITypographyProps)
  | ({ new: true } & MUITypographyProps)

export const Typography: React.FC<TypographyProps> = (props) =>
  props.new ? <MUIMappedTypography {...props} /> : <MUITypography {...props} />

export default Typography
